import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Hi, I'm Jeff.
            <br className="hidden lg:inline-block" /> Welcome to my page!
          </h1>
          <p className="mb-8 leading-relaxed">
            I am a Software Engineer looking for employment as a front end or
            full stack engineer. I am also a a dog lover and adventurer who
            enjoys backpacking and sailing! This is a site I built to showcase
            all of the projects I have developed, or worked on a team to
            develop.
          </p>
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex text-white bg-purple-500 border-0 py-2 px-6 focus:outline-none hover:bg-purple-600 rounded text-lg"
            >
              Work With Me
            </a>
            <a
              href="#projects"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg"
            >
              See My Work
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-fill object-center rounded w-full"
            alt="hero"
            src="https://i.pcmag.com/imagery/articles/00l8p1iqqfNP3HRG3TtTgXl-1.fit_lim.size_1600x900.v1587974089.jpg"
          />
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/About.js